import logo from './logo.svg';
import './App.css';
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WelcomePage from './pages/WelcomePage';
import AgenticAITool from "./pages/AgenticAITool";
import RAGChatbotPage from "./pages/RAGChatbotPage";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomePage />} />

        <Route path="/agentic-ai" element={<AgenticAITool />} />
        <Route path="/rag-chatbot" element={<RAGChatbotPage />} />
      </Routes>
    </Router>
  );
}

export default App;
